import axios from '../axios/axios'

export default {
  state: {
    employees: []
  },
  mutations: {
    loadEmployees(state, employees) {
      state.employees = employees
    },
    updateEmployee(state, {id, department_id, department_name}) {
      const employee = state.employees.find(employee => employee.id === Number(id))

      employee.department_id = department_id
      employee.department_name = department_name
    }
  },
  actions: {
    async fetchEmployees({commit}) {
      try {
        commit('setLoading', true)
        const response = await axios.get('/employees')
        commit('loadEmployees', response.data.employees)
        commit('setLoading', false)
      } catch (e) {
        commit('setNotification', {type: 'error', text: e.response.data.message})
        commit('setLoading', false)
      }
    },
    async updateEmployee({commit}, {id, departmentId}) {
      try {
        commit('setLoading', true)
        const response = await axios.put(`/employees/${id}`, {department_id: departmentId})
        commit('updateEmployee', response.data.employee)
        commit('setNotification', {type: 'success', text: response.data.message})
        commit('setLoading', false)
      } catch (e) {
        commit('setNotification', {type: 'error', text: e.response.data.message})
        commit('setLoading', false)
      }
    }
  },
  getters: {
    employees(state) {
      return state.employees
    }
  }
}
